// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import global from './global/home'

// 引入vant image 组件
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import aboutLang from './utils/lang/aboutUs'
import homeLang from './utils/lang/home'
import productLang from './utils/lang/product.js'
import joinLang from './utils/lang/joinUs'
import science from './utils/lang/science'
import zoologyLang from './utils/lang/zoology'
import presscenter from './utils/lang/presscenter'
import componentsLang from './utils/lang/components'
Vue.prototype.aboutLang = aboutLang
Vue.prototype.homeLang = homeLang
Vue.prototype.productLang = productLang
Vue.prototype.joinLang = joinLang
Vue.prototype.scienceLang = science
Vue.prototype.zoologyLang = zoologyLang
Vue.prototype.presscenter = presscenter
Vue.prototype.componentsLang = componentsLang
// 引入vue封装的swiper插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'  //引入样式
Vue.use(VueAwesomeSwiper)

// 引入地图
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

//引入jq
import 'jquery'

// 引入vue-i18n（中英文）
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 挂载
const i18n = new VueI18n({
  // locale: 'zh-CN',    // 语言标识
  locale: 'zh-CN',    // 语言标识
})

Vue.prototype.global = global   //中英文


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js